import React, { useEffect, useState, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { isAfter, startOfDay } from 'date-fns';
import get from 'lodash/get';
import Grid from '@mui/material/Grid';
import MerchantHeader from '../../components/MerchantHeader/MerchantHeader';
import PaymentsTile from '../../components/PaymentsTile/PaymentsTile';
import InvoiceTile from '../../components/InvoiceTile/InvoiceTile';
import Footer from '../../components/Footer/Footer';
import ErrorModal from '../../components/ErrorModal/ErrorModal';
import packageJson from '../../../package.json';
import * as apiActions from '../../actions/api';
import { showErrorModal } from '../../actions/modal';
import { invoiceDataLoaded } from '../../actions/invoice';
import * as config from '../../config';
import './styles.css';
import { InvoiceContext } from '../../components/context/invoiceData';

const quickInvoiceRegex = /^[a-zA-Z0-9]{24}$/;

// DO NOT remove these console logs:

// eslint-disable-next-line no-console
console.log(packageJson.version);
// eslint-disable-next-line no-console
console.log(config);

const QuickInvoice = () => {
  const [quickInvoice, setQuickInvoice] = useState({});
  const [invoiceID, setInvoiceID] = useState('');
  const invoiceContext = useContext(InvoiceContext);
  const dispatch = useDispatch();

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const quickInvoiceId = window.encodeURIComponent(urlParams.get('id') || '');
    const safeQuickInvoiceId = quickInvoiceRegex.test(quickInvoiceId) === true ? quickInvoiceId : '';

    setInvoiceID(safeQuickInvoiceId);

    apiActions.getQuickInvoiceData(safeQuickInvoiceId).then((response) => {
      let errorMessage = 'Something went wrong. Please try again later.';
      const locationName = get(response, 'data.quickinvoice.location.name') || 'us';
      const expireDate = get(response, 'data.quickinvoice.quick_invoice.expire_date');
      const { status } = response;
      if (status !== 200) {
        if (status === 404) {
          errorMessage = 'We cannot locate your Invoice.';
        }
        dispatch(showErrorModal(errorMessage));
      } else if (expireDate && isAfter(startOfDay(new Date()), startOfDay(new Date(expireDate)))) {
        errorMessage = `The Invoice link you've tried to access has expired. Please contact ${locationName} if you have questions.`;
        dispatch(showErrorModal(errorMessage));
      } else {
        setQuickInvoice(get(response, 'data.quickinvoice', {}));
        invoiceContext.setInvoiceData(get(response, 'data.quickinvoice'));
        dispatch(invoiceDataLoaded(get(response, 'data.quickinvoice', {})));
      }
    });
  }, []);

  return (
    <>
      <MerchantHeader quickInvoice={quickInvoice} />
      <div className="QuickInvoice">
        <Grid container className="quick-invoice-container">
          <Grid item xs={12} md={6} lg={6} className="quick-invoice-grid-item">
            <InvoiceTile quickInvoice={quickInvoice} />
          </Grid>
          <Grid item xs={12} md={6} lg={6} className="quick-invoice-grid-item">
            <PaymentsTile invoiceID={invoiceID} />
          </Grid>
          <Grid className="qi-app-footer" item xs={12} md={12} lg={12}>
            <Footer note={get(quickInvoice, 'note', '')} />
          </Grid>
        </Grid>
      </div>
      <ErrorModal />
    </>
  );
};

export default QuickInvoice;
